export const defaultElement = 'button';
export const buttonSizes = ['sm', 'md'];
export const buttonVariants = ['primary', 'secondary', 'tertiary', 'ghost', 'ghostBlue', 'success', 'warning'];